import { z } from 'zod';
import { ChannelSchema, DefinitionStatusSchema, FieldDefinitionSchema } from './schema';
import { ZoneDefinitionSchema } from './zone-definition';
export const SurfaceDefinitionSchema = z.object({
    label: z.string(),
    description: z.string(),
    status: DefinitionStatusSchema,
    channels: z.array(ChannelSchema),
    fieldDefinitions: z.array(FieldDefinitionSchema),
    zonesDefinitions: z.array(ZoneDefinitionSchema).optional()
});
export const SurfaceDefinitionVersionSchema = z.record(z.string(), SurfaceDefinitionSchema);
export const WebSurfaceDefinitionSchema = z.object({
    name: z.string(),
    schema: z.string(),
    type: z.literal('surface'),
    versions: SurfaceDefinitionVersionSchema
});
/**
 * Create a versioned surface from a surface definition json.
 * @param  definition  Surface definition json, conforming with SurfaceDefinition type.
 * @returns - Surface definition object.
 * @example
 * ```ts
 *    import { createSurfaceDefinitionVersion } from '@atlassiansox/bxp-definition-sdk';
 *
 *    export const ExampleSurface = createSurfaceDefinitionVersion({
 *      {
 *         label:'Example Surface Definition',
 *         description:'Example Surface Definition',
 *         status:'active',
 *         channels:'web',
 *         fieldDefinitions:[
 *           {
 *             name:'title',
 *             type:'string',
 *             label:'Title'
 *           },
 *           {
 *             name:'description',
 *             type:'string',
 *             label:'Description'
 *           }
 *         ],
 *         zonesDefinitions:[
 *           {
 *             name:'main',
 *             label:'Main Zone',
 *             description:'A zone where an example module can be added.',
 *             status:'active',
 *             validations:{
 *               moduleRestrictions:[ {
 *                   name: 'SomeModule',
 *                   version: '1'
 *               } ]
 *             }
 *           }
 *         ]
 *      }
 *   });
 * ```
 */
export function createSurfaceDefinitionVersion(surfaceDefinition) {
    return SurfaceDefinitionSchema.parse(surfaceDefinition);
}
//# sourceMappingURL=surface-definition.js.map